import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ShamanAuthGuard } from 'shaman-auth';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AccountsComponent } from './accounts/accounts.component';
import { SettingsComponent } from './settings/settings.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [ShamanAuthGuard] },
  { path: 'accounts', component: AccountsComponent, canActivate: [ShamanAuthGuard] },
  { path: 'settings', component: SettingsComponent, canActivate: [ShamanAuthGuard] },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
